import React from 'react';
import { BarChartOutlined, RocketOutlined, TrophyOutlined } from '@ant-design/icons';

export const whatIBringData = [
  {
    title: 'Business Analysis',
    icon: <BarChartOutlined />,
    description: 'Translating complex business requirements into actionable insights and strategic solutions that drive organizational growth and efficiency.'
  },
  {
    title: 'Tech Enabled Delivery',
    icon: <RocketOutlined />,
    description: 'Leveraging cutting-edge technology and agile methodologies to deliver innovative solutions that exceed expectations and accelerate time-to-market.'
  },
  {
    title: 'Data Driven Impact',
    icon: <TrophyOutlined />,
    description: 'Utilizing advanced analytics and data science techniques to uncover meaningful patterns and drive measurable business outcomes.'
  }
];
